import * as React from "react";
import type { SVGProps } from "react";
const SvgChristianCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 21c0 .55.45 1 1 1s1-.45 1-1V10h5c.55 0 1-.45 1-1s-.45-1-1-1h-5V3c0-.55-.45-1-1-1s-1 .45-1 1v5H6c-.55 0-1 .45-1 1s.45 1 1 1h5z"
    />
  </svg>
);
export default SvgChristianCross;
